import { Grid } from "@material-ui/core";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import firebase, {
  axiosWithToken,
  functionBaseUrl,
} from "../../common/firebase";
import { useCustomTokenAuth } from "../../hooks/useCustomTokenAuth";
import { useAuthUser } from "../../hooks/useAuthUser";
import { useUserData } from "../../hooks/useUserData";
import { userService } from "../../services/user";
import Spinner from "../shared/spinner/Spinner";

const RouteWithLayout = ({
  layout: Layout,
  component: Component,
  allowedRoles,
  ...rest
}) => {
  const location = useLocation();
  const { signInWithCustomToken } = useCustomTokenAuth();

  const [customTokenLoading, setCustomTokenLoading] = useState(true);

  const { user, loading } = useAuthUser();
  const { userData } = useUserData();

  const pageExceptions = [
    "/sign-in",
    "/sign-up",
    "/welcome",
    "/offer",
    "/invitational",
    "/swing-analysis-offer",
    "/golfpad",
    "/metagolfclub",
    "/dollar-driver-club",
    "/ccgolf",
    "/mark-crossfield",
    "/holiday-offer",
    "/promo-checkout",
    "/promo-checkout/",
    "/golf-genius",
    "/golf-genius/open-session",
    "/golf-genius/open-session/",
    "/golf-genius/start-session",
    "/golf-genius/start-session/",
    "/2023",
    "/not-found",
    "/terms-of-service",
    "/privacy",
    "/forgot-password",
    "/custom-token-auth",
    "/plans",
    "/speed-assessment-human",
    "/speed-assessment-ai",
    "/roast-my-swing",
    "/manage-devices",
    "/student-credits",
  ];

  useEffect(() => {
    const runCustomTokenAuth = async () => {
      const token = new URLSearchParams(location.search).get("customToken");

      if (token) {
        try {
          const signInRes = await signInWithCustomToken(token);
        } catch (error) {
          console.error("Custom token auth failed:", error);
        }
      }
      setCustomTokenLoading(false);
    };

    runCustomTokenAuth();
  }, [location.search, signInWithCustomToken]);

  const isLoading = loading || customTokenLoading;

  return (
    <Route
      {...rest}
      render={(matchProps) => {
        const isExempted =
          pageExceptions.includes(matchProps.location.pathname) ||
          (user && matchProps.location.pathname === "/email-verification");

        if (isLoading) {
          return (
            <Layout>
              <div className="flex justify-center items-center text-center h-screen">
                <Spinner color="primary500" size="md" />
              </div>
            </Layout>
          );
        }

        if (isExempted || user) {
          if (
            user &&
            !pageExceptions.includes(matchProps.location.pathname) &&
            !user.emailVerified &&
            matchProps.location.pathname !== "/email-verification"
          ) {
            return <Redirect to="/email-verification" />;
          }

          if (
            isExempted ||
            !allowedRoles ||
            allowedRoles.includes(userData?.role)
          ) {
            return (
              <Layout>
                <Component {...matchProps} />
              </Layout>
            );
          } else {
            return <Redirect to="/dashboard" />;
          }
        } else {
          return <Redirect to="/sign-in" />;
        }
      }}
    />
  );
};

RouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.string,
};

export default RouteWithLayout;
